import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { BaseDropout } from '@interfaces';
import { MentorDropoutsGridPart } from '../../../../../ui/widget/shared-grids/mentor-dropouts-grid/mentor-dropouts-grid.part';
import { VolunteeringMentorsService } from '../../volunteering-mentors.service';

export interface AccMentorDropout extends BaseDropout {
	accMentorId: number,
	accTeamId: number,
	volunteerId: number,
	personId: number,
	name: string,
	accId: number,
	accName: string,
	facilitatorName: string,
	dropoutReason: string,
}


@Component({
	selector: 'volunteering-mentor-dropouts-view-part',
	standalone: true,
	imports: [MentorDropoutsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './dropped-out-mentors-view.part.html',
})
export class VolunteeringMentorDropoutsViewPart {

	readonly pageService = inject(VolunteeringMentorsService);

	public droppedOutMentors = computed(() => this.pageService.areaService.volunteeringData()?.inCohortMentors.filter(v => !!v.dropout) || []);
}